import { render, staticRenderFns } from "./AccessibleVideo.vue?vue&type=template&id=ed222d28&scoped=true&"
import script from "./AccessibleVideo.vue?vue&type=script&lang=js&"
export * from "./AccessibleVideo.vue?vue&type=script&lang=js&"
import style0 from "./AccessibleVideo.vue?vue&type=style&index=0&id=ed222d28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed222d28",
  null
  
)

export default component.exports